export default __webpack_public_path__ + "static/media/logo.b69c714c.png";